export const listCenter=[
    "HN - Trung tâm Sơn Tây",
    "HD - Trung tâm Hải Dương 2",
    "HB - Trung tâm Hòa Bình",
    "PT - Trung tâm Phú Thọ 2",
    "HT - Trung tâm Hà Tĩnh",
    "QB - Trung tâm Quảng Bình 1",
    "HP - Trung tâm Trần Nguyên Hãn",
    "HN - Trung tâm Linh Đàm 2",
    "HN - Trung tâm Hàng Da",
    "HN - Trung tâm Vĩnh Hưng",
    "HN - Trung tâm Green Park Việt Hưng ",
    "HN - Trung tâm Nguyễn Tuân",
    "HN - Trung Tâm Ngoại Giao Đoàn",
    "HY - Trung tâm Hưng Yên",
    "BG - Trung tâm Bắc Giang",
    "HN - Trung tâm Xuân Diệu",
    "VP - Trung tâm Phúc Yên",
    "QN - Trung tâm Móng Cái",
    "HN - Trung tâm Kim Giang",
    "HN - Trung tâm Trương Định",
    "HN - Trung tâm Núi Trúc",
    "HN - Trung tâm GOLDEN PALACE - Mễ Trì",
    "HN - Trung tâm Mipec Long Biên",
    "HN - Trung tâm Lê Trọng Tấn",
    "VP - Trung tâm Vĩnh Phúc 2",
    "NB - Trung tâm Ninh Bình",
    "HD - Trung tâm Hải Dương 1 ",
    "HN - Trung tâm Vinhomes Gardenia Mỹ Đình",
    "HN - Trung tâm Cầu giấy",
    "LC - Trung tâm Lào Cai",
    "ĐN1 - Trung tâm Đà nẵng 1",
    "QN - Trung tâm Hạ Long",
    "QN - Trung tâm Cẩm Phả",
    "QN - Trung tâm Bãi Cháy",
    "QN - Trung tâm Uông Bí",
    "NA - Trung tâm Vinh 2",
    "PT - Trung tâm Phú Thọ",
    "HN - Trung tâm Trung Kính",
    "HUE - Trung tâm Huế",
    "NA - Trung tâm Vinh 1",
    "HNA - Trung tâm Hà Nam",
    "ĐN2 - Trung tâm Đà nẵng 2",
    "TN - Trung tâm Thái Nguyên",
    "HN - Trung tâm Xa La",
    "VP - Trung tâm Vĩnh Phúc 1",
    "BN - Trung tâm Từ Sơn",
    "HN - Trung tâm Định Công",
    "HN - Trung tâm Lý Thường Kiệt",
    "HN - Trung tâm Lê Đại Hành",
    "BN - Trung tâm Bắc Ninh",
    "HN - Trung tâm Hà Đông 1",
    "TH - Trung tâm Thanh Hóa",
    "TB - Trung tâm Thái Bình",
    "HN - Trung tâm Thụy Khuê",
    "HN - Trung tâm Láng Hạ",
    "HN - Trung tâm Hà Đông 2",
    "HP - Trung tâm Lê Hồng Phong",
    "HN - Trung tâm Mỹ Đình 2",
    "HN - Trung tâm Kim Liên",
    "HN - Trung tâm Hoàng Đạo Thúy 1 ",
    "HN - Trung tâm Nguyễn Sơn - Nguyễn Văn Cừ",
    "HP - Trung tâm Quang Trung",
    "HN - Trung tâm Linh Đàm",
    "HN - Trung tâm Times City",
    "HN - Trung tâm Hoàng Quốc Việt",
    "HCM - Trung tâm Bàu Cát",
    "KG - Trung tâm Rạch Giá",
    "ĐL - Trung tâm Buôn Ma Thuột",
    "CT - Trung tâm Cần Thơ",
    "HCM - Trung tâm Phạm Đình Hổ",
    "HCM - Trung tâm Bến Vân Đồn",
    "HCM - Trung tâm Hậu Giang 2",
    "BĐ - Trung tâm Quy Nhơn",
    "HCM - Trung tâm Thanh Đa",
    "KH - Trung tâm Nha Trang",
    "GL - Trung tâm Gia Lai",
    "HCM - Trung tâm Trần Bình Trọng",
    "HCM - Trung tâm Võ Văn Tần",
    "HCM - Trung tâm Nguyễn Tri Phương",
    "HCM - Trung Tâm Trần Đình Xu",
    "HCM - Trung tâm Lạc Long Quân",
    "HCM - Trung tâm Nguyễn Sơn",
    "HCM - Trung tâm Trần Trọng Cung",
    "HCM - Trung tâm Hồng Hà",
    "HCM - Trung Tâm Him Lam",
    "HCM - Trung tâm Phan Huy Ích",
    "HCM - Trung tâm Lê Văn Việt",
    "HCM - Trung tâm Flemington",
    "HCM - Trung tâm Tên Lửa",
    "HCM - Trung tâm Lê Đức Thọ",
    "HCM - Trung tâm Nguyễn Duy Trinh",
    "HCM - Trung tâm Bắc Hải",
    "ĐNO - Trung tâm Biên Hòa",
    "HCM - Trung tâm Cộng Hòa",
    "HCM - Trung tâm Phan Văn Hớn",
    "HCM - Trung tâm Sài Gòn Pearl",
    "HCM - Trung tâm Nguyễn Thị Thập",
    "VT - Trung Tâm Vũng Tàu",
    "HCM - Trung tâm Hai Bà Trưng - Q3",
    "HCM - Trung tâm Phan Văn Trị",
    "HCM - Trung Tâm Trường Chinh",
    "HCM - Trung Tâm Tân Phú",
    "HCM - Trung tâm Gia Hòa",
    "HCM - Trung tâm Phạm Văn Đồng",
    "HCM - Trung tâm Phan Xích Long",
    "HCM - Trung tâm Lê Văn Sỹ",
    "HCM - Trung tâm Quang Trung - Gò Vấp",
    "HCM - Trung tâm Võ Văn Ngân",
    "BD - Trung tâm Bình Dương"
]
